import React, { useCallback, useRef } from 'react';
import { Popup, Portal } from '@gravity-ui/uikit';
import Foldable from '../../../components/Foldable/Foldable';
import { NavigationItemType } from '../../../models';
import { block } from '../../../utils';
import { ItemColumnName } from '../../constants';
import NavigationItem from '../NavigationItem/NavigationItem';
import './MobileNavigation.css';
const b = block('mobile-navigation');
const MobileNavigationDropdown = ({ data, onItemClick, onToggle, isOpened = false, }) => {
    const ref = useRef(null);
    return (React.createElement("div", { ref: ref, className: b('dropdown') },
        React.createElement(NavigationItem, { data: data, onClick: onToggle, isOpened: isOpened }),
        isOpened && (React.createElement(Popup, { anchorRef: ref, open: isOpened, className: b('popup') }, data.items.map((item) => (React.createElement(NavigationItem, { key: item.text, data: item, className: b('dropdown-item'), onClick: onItemClick })))))));
};
const MobileNavigationItem = ({ item, index, isOpened, activeItemId, onActiveItemChange, column, onClose, }) => {
    const id = `${column}-${index}`;
    const isActive = id === activeItemId && isOpened;
    const toggleActive = useCallback((e) => {
        e.stopPropagation();
        if (onActiveItemChange) {
            onActiveItemChange(isActive ? undefined : `${column}-${index}`);
        }
    }, [onActiveItemChange, isActive, column, index]);
    const onItemClick = useCallback((e) => {
        toggleActive(e);
        onClose();
    }, [toggleActive, onClose]);
    return (React.createElement("li", { key: index, className: b('rows-item') }, item.type === NavigationItemType.Dropdown ? (React.createElement(MobileNavigationDropdown, { data: item, onToggle: toggleActive, isOpened: isActive, onItemClick: onItemClick })) : (React.createElement(NavigationItem, { data: item, onClick: onItemClick }))));
};
const MobileNavigation = (props) => {
    if (typeof window === 'undefined') {
        return null;
    }
    const { isOpened, topItems, bottomItems, activeItemId, onActiveItemChange, onClose } = props;
    return (React.createElement(Portal, null,
        React.createElement(Foldable, { key: topItems === null || topItems === void 0 ? void 0 : topItems.length, className: b(), isOpened: Boolean(isOpened) },
            React.createElement("div", { className: b('wrapper') },
                React.createElement("nav", { className: b('nav') },
                    React.createElement("ul", { className: b('rows') }, topItems === null || topItems === void 0 ? void 0 : topItems.map((link, index) => (React.createElement(MobileNavigationItem, { key: index, item: link, column: ItemColumnName.Top, index: index, isOpened: isOpened, activeItemId: activeItemId, onClose: onClose, onActiveItemChange: onActiveItemChange }))))),
                React.createElement("ul", { className: b('rows') }, bottomItems === null || bottomItems === void 0 ? void 0 : bottomItems.map((item, index) => (React.createElement(MobileNavigationItem, { key: index, item: item, column: ItemColumnName.Bottom, index: index, isOpened: isOpened, activeItemId: activeItemId, onClose: onClose, onActiveItemChange: onActiveItemChange }))))))));
};
export default MobileNavigation;
